import React, { useEffect, useRef, useState } from "react";
import { GuaranteeSection } from "../components/GuaranteeSection";
import { Hero } from "../components/Hero";
import { StickyOfferBar } from "../components/StickyOfferBar";
import { StatsStrip } from "../components/StatsStrip";
import { SituationSelector } from "../components/SituationSelector";
import { SessionWalkthrough } from "../components/SessionWalkthrough";
import { SolutionSection } from "../components/SolutionSection";
import { WorkshopsSection } from "../components/WorkshopsSection";
import { BonusesSection } from "../components/BonusesSection";
import { OfferSection } from "../components/OfferSection";
import { FaqSection } from "../components/FaqSection";
import { ClosingSection } from "../components/ClosingSection";
import { SiteFooter } from "../components/SiteFooter";
export function Landing() {
  const heroRef = useRef<HTMLDivElement>(null);
  const cardRef = useRef<HTMLDivElement>(null);
  const [pastHero, setPastHero] = useState(false);
  const [cardVisible, setCardVisible] = useState(false);
  useEffect(() => {
    const heroObserver = new IntersectionObserver(([entry]) => setPastHero(!entry.isIntersecting));
    const cardObserver = new IntersectionObserver(([entry]) => setCardVisible(entry.isIntersecting), {
      threshold: 0,
      rootMargin: "80px 0px 80px 0px"
    });
    if (heroRef.current) heroObserver.observe(heroRef.current);
    if (cardRef.current) cardObserver.observe(cardRef.current);
    return () => {
      heroObserver.disconnect();
      cardObserver.disconnect();
    };
  }, []);
  return <div className="site-surface min-h-screen w-full overflow-x-hidden font-sans antialiased" data-id="element-325" data-mp="c7of4xt3bvpy">
      <StickyOfferBar visible={pastHero && !cardVisible} data-id="element-326" data-mp="79my0if866h4" />
      <a className="skip-link" href="#main-content" data-id="element-327" data-mp="770sspft4322">Skip to content</a>
      <main id="main-content" data-id="element-328" data-mp="14pak3uc7ry2g">
        <div ref={heroRef} data-id="element-329" data-mp="14qlpfylb5dvo">
          <Hero data-id="element-330" data-mp="zy2aoyavwcpa" />
        </div>
        <StatsStrip data-id="element-331" data-mp="zwr5qv5pcywl" />
        <SituationSelector data-id="element-332" data-mp="zwhg58okktrf" />
        <SessionWalkthrough data-id="element-333" data-mp="1iu14dvxu7xj0" />
        <SolutionSection data-id="element-334" data-mp="1itrcg2t8fgao" />
        <WorkshopsSection data-id="element-335" data-mp="1iukonjaymy07" />
        <BonusesSection data-id="element-336" data-mp="1iwdke3k1bxtf" />
        <OfferSection cardRef={cardRef} data-id="element-337" data-mp="1nsujttwopylt" />
        <GuaranteeSection data-id="element-338" data-mp="1nsm6k0wngra3" />
        <FaqSection data-id="element-339" data-mp="1nv8g2633pguy" />
        <ClosingSection data-id="element-340" data-mp="1a1z6o5f5kvcf" />
      </main>
      <SiteFooter data-id="element-341" data-mp="1a0xv7zu866u6" />
    </div>;
}